import BaseApi from './baseApi';
import INoticeOfLoss from '../models/INoticeOfLoss';
import IAuthentication from '../models/IAuthentication';
export default class OutboundsNoticeOfLossApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "NoticeOfLoss");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetOutboundsNoticeOfLoss(outboundDeliveryNoteId : string) : Promise<INoticeOfLoss[]> {
        let json : string = this.getJsonRead(outboundDeliveryNoteId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outboundsNoticeOfLoss: INoticeOfLoss[] = [];
            outboundsNoticeOfLoss = response.data as INoticeOfLoss[];
            return outboundsNoticeOfLoss;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveOutboundsNoticeOfLoss(OutboundsNoticeOfLoss: INoticeOfLoss) : Promise<string> {
        const json = this.getJsonSave(OutboundsNoticeOfLoss);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateOutboundsNoticeOfLoss(outboundsNoticeOfLoss: INoticeOfLoss) : Promise<boolean> {
        const json = this.getJsonUpdate(outboundsNoticeOfLoss);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundsNoticeOfLoss(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsNoticeOfLoss",
            "conditions": [{
                "Item1": "OutboundsNoticeOfLoss",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(noticeOfLoss: INoticeOfLoss) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idOutboundDeliveryNote",
                "Item2": noticeOfLoss.idDeliveryNote
            }, {
                "Item1": "idWarehouse",
                "Item2": noticeOfLoss.idWarehouse
            }, {
                "Item1": "date",
                "Item2": noticeOfLoss.date
            }, {
                "Item1": "description",
                "Item2": noticeOfLoss.description
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsNoticeOfLoss"
        };
        return json;
    }

    private getJsonUpdate(outboundsNoticeOfLoss: INoticeOfLoss) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idOutboundDeliveryNote",
                "Item2": outboundsNoticeOfLoss.idDeliveryNote
            }, {
                "Item1": "idWarehouse",
                "Item2": outboundsNoticeOfLoss.idWarehouse
            }, {
                "Item1": "date",
                "Item2": outboundsNoticeOfLoss.date
            }, {
                "Item1": "description",
                "Item2": outboundsNoticeOfLoss.description
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsNoticeOfLoss",
            "keyvalue": outboundsNoticeOfLoss.id
        };
        return json;
    }

    private getJsonRead(outboundDeliveryNoteId : string) : any {
        const json = {
            "fields": [{
                "Item1": "OutboundsNoticeOfLoss",
                "Item2": "id"
            }, {
                "Item1": "OutboundsNoticeOfLoss",
                "Item2": "idOutboundDeliveryNote as idDeliveryNote"
            }, {
                "Item1": "OutboundsNoticeOfLoss",
                "Item2": "idWarehouse"
            }, {
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "OutboundsNoticeOfLoss",
                "Item2": "date"
            }, {
                "Item1": "OutboundsNoticeOfLoss",
                "Item2": "description"
            }],
            "tables": [{
                "Item1": "OutboundsNoticeOfLoss"
            }, {
                "Item1": "Warehouses"
            }],
            "joins": [{
                "Item1": "OutboundsNoticeOfLoss",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "OutboundsNoticeOfLoss",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "OutboundsNoticeOfLoss",
                "Item2": "idOutboundDeliveryNote",
                "Item3": "=",
                "Item4": outboundDeliveryNoteId
            }]
        };
        return json;
    }
}
